import { styled } from '@mui/material/styles'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'

import Html from '../Html/Html'

const Container = styled('div')(({ theme }) => ({
  overflowWrap: 'break-word',
}))

function FundClassLegalText({ content = [], activeShareClass = {} }) {
  const isInShareClass = useMemo(
    () => (item) =>
      !item.share_classes?.length ||
      item.share_classes.some(
        (shareClass) => shareClass.title === activeShareClass.title
      ),
    [activeShareClass]
  )

  return (
    <Container>
      {content
        .filter(({ html }) => html)
        .map(
          (item, index) =>
            isInShareClass(item) && <Html key={index} content={item.html} />
        )}
    </Container>
  )
}

FundClassLegalText.propTypes = {
  content: PropTypes.any,
  activeShareClass: PropTypes.any,
}

export default FundClassLegalText
